import { CircleUserRound, Mic, Video, Volume2 } from 'lucide-react';
import * as React from 'react';
import { Badge } from '../Badge/Badge';

const ResponderCard = ({ incident = 'Incident Name', users }) => {
  return (
    <div className="flex justify-between gap-2 bg h-28 p-3 border rounded-md shadow-sm min-w-52 w-52">
      <div className="flex flex-col items-start gap-2">
        <div className="flex gap-2 flex-1">
          <div className="relative h-8 shrink-0">
            <CircleUserRound size={'2rem'} />
            <span
              className={`absolute bottom-0 right-0 w-2.5 h-2.5 ${users.presence === 'online' ? 'bg-success-strong' : users.presence === 'offline' ? 'bg-error-strong' : 'bg-input'} border-2 border-onColor rounded-full z-10`}
            />
          </div>

          <div className="flex flex-col">
            <p className="font-medium text-sm leading-5 truncate max-w-24">{users?.displayName}</p>
            <Volume2 size={'1rem'} />
          </div>
        </div>

        <div className="flex flex-col items-start gap-1">
          <span className="text-xs font-medium leading-4 truncate">{incident}</span>
          <div className="flex">
            <Badge variant="SoftGreen" size="sm">
              {' '}
              {users?.widebridgepresence?.availability?.new || '-'}
            </Badge>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-1">
        <button className="w-8 h-8 rounded-full bg shadow-md hover:bg-primary-hover hover:text-onColor transition flex items-center justify-center">
          <Mic size={'1rem'} />
        </button>
        <button className="w-9 h-9 rounded-full bg shadow-md hover:bg-primary-hover hover:text-onColor transition flex items-center justify-center">
          <Video size={'1rem'} />
        </button>
      </div>
    </div>
  );
};

export default ResponderCard;
